var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassTable",
    {
      staticClass: "rate-category-table",
      attrs: { isCheckable: false, size: "medium" }
    },
    [
      _c(
        "CompassTableHead",
        { on: { sort: _vm.handleSort } },
        [
          _c("CompassTableHeadCell", [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.$t.__(
                    "settings.taxes.VatSettings.rates.table.header.by_default"
                  )
                ) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _c(
            "CompassTableHeadCell",
            {
              attrs: {
                sortable: {
                  direction: "",
                  orderBy: "category"
                }
              }
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.$t.__(
                      "settings.taxes.VatSettings.rates.table.header.category"
                    )
                  ) +
                  "\n        "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "CompassTableHeadCell",
            {
              attrs: {
                sortable: {
                  direction: "",
                  orderBy: "documents"
                }
              }
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.$t.__(
                      "settings.taxes.VatSettings.rates.table.header.documents"
                    )
                  ) +
                  "\n        "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "CompassTableHeadCell",
            {
              attrs: {
                sortable: {
                  direction: "",
                  orderBy: "applied_vat"
                }
              }
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.$t.__(
                      "settings.taxes.VatSettings.rates.table.header.applied_vat"
                    )
                  ) +
                  "\n        "
              )
            ]
          ),
          _vm._v(" "),
          _c("CompassTableHeadCell", [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.$t.__(
                    "settings.taxes.VatSettings.rates.table.header.document_currency"
                  )
                ) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _c(
            "CompassTableHeadCell",
            {
              attrs: {
                sortable: {
                  direction: "",
                  orderBy: "accounting_code"
                }
              }
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.$t.__(
                      "settings.taxes.VatSettings.rates.table.header.accounting_code"
                    )
                  ) +
                  "\n        "
              )
            ]
          ),
          _vm._v(" "),
          _c("CompassTableHeadCell"),
          _vm._v(" "),
          _c("CompassTableHeadCell")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "CompassTableBody",
        _vm._l(_vm.localRateCategories, function(rate) {
          return _c(
            "CompassTableRow",
            { key: rate.id, staticClass: "rate-category-table__row" },
            [
              _c(
                "CompassTableBodyCell",
                {
                  staticClass: "rate-category-table__fixed-width-cell",
                  attrs: { alignContent: "center" }
                },
                [
                  _c("CompassRadio", {
                    attrs: {
                      modelValue: rate.id,
                      label: "",
                      checked: rate.id === _vm.defaultRateCategory
                    },
                    on: {
                      change: function($event) {
                        return _vm.handleDefaultRateChange(rate.id)
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "CompassTableBodyCell",
                { staticClass: "rate-category-table__multi-line-cell" },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(rate.label) +
                      "\n                "
                  ),
                  _c("div", { staticClass: "rate-category-table__caption" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.getRatePriceTypeLabel(rate)) +
                        "\n                "
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "CompassTableBodyCell",
                [
                  rate.includes_taxes
                    ? [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t.__("common.labels.taxes_included")) +
                            "\n                "
                        )
                      ]
                    : [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t.__("common.labels.taxes_excluded")) +
                            "\n                "
                        )
                      ]
                ],
                2
              ),
              _vm._v(" "),
              _c("CompassTableBodyCell", [
                _vm._v(" " + _vm._s(_vm.getVatLabel(rate)) + " ")
              ]),
              _vm._v(" "),
              _c(
                "CompassTableBodyCell",
                { staticClass: "rate-category-table__multi-line-cell" },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(rate._embed.currency.symbol) +
                      "\n                "
                  ),
                  _vm.isDefaultCurrency(rate)
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "rate-category-table__caption typographies-paragraph-small-regular"
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.$t.__(
                                  "settings.taxes.VatSettings.rates.table.account_currency"
                                )
                              ) +
                              "\n                "
                          )
                        ]
                      )
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c("CompassTableBodyCell", [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      rate.accounting.accounting_code_id === null
                        ? _vm.$t.__(
                            "settings.taxes.VatSettings.rates.table.accounting_code_product"
                          )
                        : _vm.getAccountingCodeById(
                            rate.accounting.accounting_code_id
                          )
                    ) +
                    "\n            "
                )
              ]),
              _vm._v(" "),
              _c(
                "CompassTableBodyCell",
                [
                  _c(
                    "CompassTooltip",
                    {
                      attrs: {
                        content: _vm.deleteButtonTooltip(rate),
                        arrow: false
                      }
                    },
                    [
                      _c("CompassIconButton", {
                        attrs: {
                          disabled: rate.is_default,
                          icon: "bin",
                          variant: "destructive"
                        },
                        on: {
                          click: function($event) {
                            return _vm.deleteRateCategory(rate.id)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "CompassTableBodyCell",
                [
                  _c(
                    "CompassTooltip",
                    {
                      attrs: {
                        content: _vm.$t.__("common.actions.edit_alt"),
                        arrow: false
                      }
                    },
                    [
                      _c("CompassIconButton", {
                        attrs: { icon: "edit" },
                        on: {
                          click: function($event) {
                            return _vm.handleEdit(rate)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }